import { FormControl, FormGroup } from '@angular/forms';
import { Cartridge } from '@markant-platform/cartridge/model';

export type UpgradeServiceVariantForm = FormGroup<{
  cartridge: FormControl<Cartridge | null>;
  variant: FormControl<string | null>;
  billingViaPlatform: FormControl<string | null>;
  individualPrice: FormControl<string | null>;
  responsibleUserEmail: FormControl<string | null>;
  bookingReference: FormControl<string | null>;
}>;
export type AdditionalOrgDataForm = FormGroup<{
  masterKIN: FormControl<string | null>;
  billingEmail: FormControl<string | null>;
  billingLanguage: FormControl<string | null>;
}>;

export const NOT_APPLICABLE = 'N/A';
